import { Icon } from './common/components/Icon'
import { Header, PageLayout } from './components'
import { Card, CardContent } from './components/ui'

export const MaintenancePage = () => {
  return (
    <PageLayout authPage className="pt-0">
      <Card className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[527px] p-10 flex flex-col gap-5 items-center justify-center">
        <CardContent className="p-0 flex flex-col gap-5 items-center w-full">
          {/* Icon with glowing circle */}
          <div className="grid grid-cols-[max-content] grid-rows-[max-content] place-items-start relative shrink-0">
            <div className="col-start-1 row-start-1 ml-0 mt-0 relative size-[68.819px]">
              <div className="absolute -inset-[66.76%]">
                <Icon
                  icon="img-eclipse"
                  width="s100%"
                  height="100%"
                  viewBox="0 0 160.712 160.712"
                />
              </div>
            </div>
            <div className="col-start-1 row-start-1 ml-[14.12px] mt-[14.02px] relative size-[41.238px]">
              <Icon
                icon="img-setting"
                width="100%"
                height="100%"
                viewBox="0 0 41.238 41.238"
                fill="none"
              />
            </div>
          </div>

          {/* Content */}
          <div className="flex flex-col gap-6 items-center w-full">
            <div className="flex flex-col gap-[14px] items-center w-full">
              <h1 className="text-title-m text-monochrome-1 text-center w-full">
                Scheduled Maintenance
              </h1>
              <p className="text-body-medium text-[#a9a9a9] text-center w-full">
                To ensure the optimal performance and security of our dashboard
                management system, we conduct regular maintenance and updates.
                These activities are crucial for enhancing functionality,
                improving user experience, and addressing any potential issues.
              </p>
            </div>
          </div>

          <hr className="w-full border-monochrome-120" />

          <p className="text-subtitle-m text-accent-1 text-center w-full">
            Please try again in 15 minutes
          </p>
        </CardContent>
      </Card>
    </PageLayout>
  )
}

export default MaintenancePage
